import React from 'react'
import { ModalProps } from '../modal'
import Modal from '../modal'
import SpecialPeriodForm, { SpecialPeriodFormProps } from './special-period-form'
import { useCreateMutation, useUpdateMutation } from '../../queries/special-periods'

interface SpecialPeriodModalFormProps extends SpecialPeriodFormProps {
  isDisplayed: ModalProps['actions']['isDisplayed']
  setIsDisplayed: ModalProps['actions']['setIsDisplayed']
}

/**
 * Modal wrapper for the special period form
 * Automatically closes the modal on successful create/update
 */
const SpecialPeriodModalForm: React.FC<SpecialPeriodModalFormProps> = ({
  isDisplayed,
  setIsDisplayed,
  specialPeriod,
  employerId,
  existingTypes,
}) => {
  const createMutation = useCreateMutation()
  const updateMutation = useUpdateMutation()
  const currentMutation = specialPeriod ? updateMutation : createMutation

  // Close modal on successful mutation
  React.useEffect(() => {
    if (currentMutation.isSuccess && isDisplayed) {
      setIsDisplayed(false)
      // Reset mutation state
      currentMutation.reset()
    }
  }, [currentMutation.isSuccess, isDisplayed, setIsDisplayed, currentMutation])

  return (
    <Modal
      actions={{ isDisplayed, setIsDisplayed }}
      title={specialPeriod ? 'Modifier une période spéciale' : 'Créer une période spéciale'}
      dataTest="special-period-modal"
    >
      <SpecialPeriodForm
        specialPeriod={specialPeriod}
        employerId={employerId}
        existingTypes={existingTypes}
        onSuccess={() => {
          setIsDisplayed(false)
        }}
      />
    </Modal>
  )
}

export default SpecialPeriodModalForm
